import { useEffect, useState } from "react";
import FoodModalUpdate from "./FoodModalUpdate/FoodModalUpdate";
import RestaurantOrder from "./RestaurantOrder";

import axios from "axios";

const CartDetails = ({ cartData, cartDatas, userId, reloadApiCalling }) => {
  const [cart, setCart] = useState([]);

  const [orderDetails, setOrderDetails] = useState({});
  const [loading, setIsLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [selectedItemImage, setSelectedItemImage] = useState("");
  const [show, setShow] = useState(false);

  const apiAddress = process.env.REACT_APP_SECRET;

  const closeModal = () => {
    setShow(false);
    window.location.href = window.location.href; // Refresh the page to reflect any changes made in the cart
  };

  const getItemDetails = async (data) => {
    try {
      setShow(true);
      setIsLoading(true);
      setOrderDetails({}); // ⬅️ Clear old data here
      setSelectedItemId(data.foodItemId);
      setSelectedItemImage(data.foodItemImage);

      const response = await axios.get(
        `${apiAddress}/api/FoodItems/GetFoodItemDetailsForOrderDetailsByItemId?ItemId=${data.foodItemId}`,
      );

      setOrderDetails(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    // Update the cart state when cartData changes
    setCart(cartData);
  }, [cartData]);

  let cartId;

  if (cart && cart[0]?.id) {
    cartId = cart[0]["id"];
  }

  const handleUpdateCart = (updatedCart) => {
    if (cartId) {
      axios
        .put(`${apiAddress}/api/Cart/UpdateCart/${cartId}`, updatedCart)
        .then((response) => {
          console.log("Posted data", response.data);
        })
        .catch((error) => {
          console.error("Error updating cart:", error);
        });
    }
  };

  const handleDeleteItem = (itemId) => {
    console.log("Item to delete:", itemId);
    if (cartId) {
      axios
        .delete(
          `${apiAddress}/api/Cart/DeleteCart?CartId=${cartId}&ItemId=${itemId}`,
        )
        .then((response) => {
          console.log("Deleted data", response.data);
        })
        .catch((error) => {
          console.error("Error deleting cart:", error);
        });
    }
  };

  const reloadingApiCall = () => {
    reloadApiCalling();
  };

  return (
    <>
      {cartDatas?.map((restaurant) => (
        <RestaurantOrder
          key={restaurant.restaurantId}
          restaurant={restaurant}
          onUpdateCart={handleUpdateCart}
          onDeleteCart={handleDeleteItem}
          cart={cartDatas}
          setCart={setCart}
          getItemDetails={getItemDetails}
          refetchCartData={() => reloadingApiCall()}
        />
      ))}
      {selectedItemImage && show && (
        <FoodModalUpdate
          show={show}
          handleClose={closeModal}
          orderDetails={orderDetails}
          selectedItemImage={selectedItemImage}
          selectedItemId={selectedItemId}
          cart={cartDatas}
          // setCart={setCart}
          loading={loading}
          openingFrom="cartDetails"
        />
      )}
    </>
  );
};

export default CartDetails;
